import angular from 'angular';
import { alerts } from 'app/components/global';
import reportType from './reportType';
import directive from './report-types.directive';
import controller from './report-types.controller';


export default angular.module('app.components.reports.generatedReports.reportTypes', [
  alerts,
  reportType
])
  .directive('grReportTypes', directive)
  .controller('GRReportTypesController', controller)
  .name;

console.log('app.components.reports.generatedReports.reportTypes created');
